// src/components/layouts/app/header/desktop/MegaMenu.tsx
import React from 'react';
import { Link } from 'react-router-dom';
import { 
  Laptop, 
  Mouse, 
  Cpu, 
  HardDrive, 
  Wrench, 
  Sparkles, 
  Percent 
} from 'lucide-react';

const categories = [
  {
    icon: Laptop,
    title: 'Ordinateurs portables',
    links: [
      { name: 'MacBook', badge: 'Promo' },
      { name: 'PC Windows', badge: null },
      { name: 'Chromebook', badge: 'Nouveau' },
      { name: 'Station de travail', badge: null }
    ]
  },
  {
    icon: Mouse,
    title: 'Accessoires',
    links: [
      { name: 'Souris', badge: null },
      { name: 'Claviers', badge: null },
      { name: 'Écouteurs', badge: 'Promo' },
      { name: 'Sacoches', badge: null }
    ]
  },
  {
    icon: Cpu,
    title: 'Composants',
    links: [
      { name: 'Processeurs', badge: null },
      { name: 'RAM', badge: null },
      { name: 'SSD', badge: 'Nouveau' },
      { name: 'Cartes mères', badge: null }
    ]
  },
  {
    icon: HardDrive,
    title: 'Réseau & stockage',
    links: [
      { name: 'Disques durs', badge: null },
      { name: 'NAS', badge: null },
      { name: 'Switch', badge: null },
      { name: 'Câbles', badge: null }
    ]
  },
  {
    icon: Wrench,
    title: 'Services',
    links: [
      { name: 'Réparation', badge: null },
      { name: 'Installation', badge: null },
      { name: 'Maintenance', badge: null },
      { name: 'Conseil', badge: null }
    ]
  }
];

export const MegaMenu: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
      {categories.map((cat, idx) => (
        <div key={idx} className="space-y-3">
          <div className="flex items-center gap-2 border-b border-gray-300 pb-2">
            <cat.icon className="w-5 h-5 text-primary" />
            <h3 className="font-bold text-black">{cat.title}</h3>
          </div>
          <ul className="space-y-2">
            {cat.links.map((link, i) => (
              <li key={i}>
                <Link
                  to={`/categories/${link.name.toLowerCase().replace(/\s/g, '-')}`}
                  className="text-sm text-black hover:text-primary transition-colors duration-200 flex items-center justify-between group"
                >
                  <span>{link.name}</span>
                  {link.badge && (
                    <span className={`text-[10px] font-semibold px-2 py-0.5 rounded-full ${
                      link.badge === 'Nouveau' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-red-100 text-red-800'
                    }`}>
                      {link.badge === 'Nouveau' ? <Sparkles className="w-3 h-3 inline mr-1" /> : <Percent className="w-3 h-3 inline mr-1" />}
                      {link.badge}
                    </span>
                  )}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ))}
    </div>
  );
};